import ArticlePlaceholder from 'components/ui/article-placeholder';
import { useCallback, useContext, useEffect, useState, useRef } from 'react';

import { AuthContext } from 'context/AuthContext';

import { getFaqContent } from 'services/content.service';

type Props = {
  _id: string;
  title: string;
};

export default function FaqItem({ _id, title }: Props) {
  const [contentData, setContentData] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [opened, setOpened] = useState<boolean>(false);
  const { user } = useContext(AuthContext);
  const contentRef = useRef<HTMLDivElement>(null);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFaqContent(_id, user?.extra.rede);
      setContentData(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }, [_id, user?.extra.rede]);

  useEffect(() => {
    if (opened && !loading && typeof contentData !== 'string') {
      loadData();
    }
  }, [contentData, loadData, loading, opened]);

  useEffect(() => {
    if (opened && contentRef.current) {
      contentRef.current.focus();
    }
  }, [opened, contentData]);

  return (
    <div className="jj-faq overflow-hidden rounded-xl bg-brand-white shadow-[0_1px_2px_rgba(21,21,24,.08),0_1px_3px_rgba(25,25,28,.12)]">
      <button
        type="button"
        onClick={() => setOpened(prevState => !prevState)}
        className="flex w-full cursor-pointer items-start gap-3.5 border-none bg-transparent px-5 py-4 text-left font-display text-sm font-bold leading-snug text-content"
        aria-expanded={opened}
        aria-controls={`faq-content-${_id}`}
      >
        {/* O título cadastrado já traz o número ("1. Qual será…"): somar a posição repetia o número. */}
        <span className="min-w-0 flex-1">{title}</span>

        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--brand-blue)"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`shrink-0 transition-transform duration-200 ${opened ? 'rotate-180' : ''}`}
          aria-hidden="true"
          focusable="false"
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>

      {!!opened && (
        <div className="px-5 pb-[18px]">
          {loading ? (
            <ArticlePlaceholder />
          ) : (
            <div
              id={`faq-content-${_id}`}
              className="jj-faq-resposta border-t border-[#E5E7EB] pt-3.5"
              dangerouslySetInnerHTML={{ __html: contentData || '' }}
              tabIndex={-1}
              ref={contentRef}
            ></div>
          )}
        </div>
      )}
    </div>
  );
}
